import React from 'react';
import './ProductCard.css';
import { getProductManualPath, getProductImagePath } from '../utils/productData';
import { getCacheBustedUrl } from '../utils/cacheBuster';

const ProductCard = ({ product, arabicName }) => {
  const imagePath = getProductImagePath(product);
  const manualPath = getProductManualPath(product);
  
  const handleCardClick = () => {
    window.open(manualPath, '_blank');
  };
  
  return (
    <div className="product-card" onClick={handleCardClick}>
      <div className="product-image-container">
        <img 
          src={imagePath} 
          alt={arabicName || product.folder} 
          className="product-image"
          onError={(e) => {
            // Fallback placeholder (if exists)
            e.target.src = getCacheBustedUrl('/placeholder.png');
          }}
        />
        <div className="product-overlay">
          <span className="view-manual">عرض الدليل</span>
        </div>
      </div>
      <div className="product-info">
        <h3 className="product-name">{arabicName || product.folder}</h3>
      </div>
    </div>
  );
};

export default ProductCard;

